import permissionRouteGuard from '@/helpers/router/permissionRouteGuard'
import setMetaTagsFromRouter from '@/helpers/router/setMetaTagsFromRouter'
import token from '@/services/token'
import store from '@/store'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

export default (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): void => {
  // check if token is valid on first enter
  if (from.name === null) {
    store.dispatch('auth/clearUserOnInvalidToken')
  }
  const isLogged: boolean = store.getters['auth/isLogged'] === true && token.isTokenValid()
  // block login page for logged users
  if (to.name === 'Login' && isLogged) {
    return next({ name: from.name || 'Home', query: from.query })
  }

  // action if route require auth
  if (to.matched.some((record) => record.meta.requireAuth === true)) {
    if (isLogged) {
      // check permission for logged user
      const permissionGuard = permissionRouteGuard(to, from, next, store.getters['auth/getUser'])
      if (permissionGuard !== false) {
        return permissionGuard
      }
      return setMetaTagsFromRouter(to, from, next)
    }
    return next({ name: 'Login', query: { previous: to.path } })
  }

  return setMetaTagsFromRouter(to, from, next)
}
